// Site Configuration - Edit this file to update your website content
// This makes it easy to manage all your content in one place

export const SITE_CONFIG = {
  // Brand Info
  brand: {
    name: "Nouveau Riche Legacy",
    tagline: "Build with intention. Create a legacy that lasts.",
    description: "Black-owned, woman-led platform built to close the wealth gap for real. We merge financial literacy, credit strategy, artistic expression, AI, and Web3 innovation.",
    email: "dporterfield@nouveaurichelegacy.com",
    affiliateLink: "https://novaemoney.com/nouveauriche22/become-an-affiliate",
    bookingLink: "https://www.nouveaurichelegacy.com/booking-calendar/business-consultation",
  },
  
  // Social Links
  social: {
    instagram: "https://www.instagram.com/nouveaurichelegacy",
    facebook: "https://www.facebook.com/nouveaurichelegacy",
    youtube: "https://www.youtube.com/nouveaurichelegacy",
  },
  
  // Services
  services: [
    {
      id: "financial-literacy",
      title: "Financial Literacy",
      subtitle: "Build Generational Wealth",
      description: "Financial literacy at Nouveau Riche Legacy gives you the tools to take control of your money and build wealth with intention. Click to learn, apply, and start creating a legacy that lasts.",
      image: "https://static.wixstatic.com/media/11062b_9b52a0adb0ac4756a04a9e7aeaa7ce3d~mv2.jpeg",
      link: "/financial-consulting",
      externalLink: "http://www.novaemoney.com/nouveauriche22",
      cta: "Learn More"
    },
    {
      id: "consultations",
      title: "Consultations",
      subtitle: "Strategy & Clarity",
      description: "Consultations are designed to give you clarity, strategy, and a personalized path forward. Click to book your session and start building with intention.",
      image: "https://static.wixstatic.com/media/b3a4967ff3214a43b9ca98e1b3b8777b.jpg",
      link: "/media-services",
      externalLink: "https://www.nouveaurichelegacy.com/booking-calendar/business-consultation",
      cta: "Book Now"
    },
    {
      id: "artist-management",
      title: "Artist Management",
      subtitle: "Grow Your Creative Career",
      description: "Artist memberships give you access to opportunities, exposure, and resources to grow your creative career with intention. Click to join and start building as an artist and a brand.",
      image: "https://images.pexels.com/photos/1105666/pexels-photo-1105666.jpeg",
      link: "/art-gallery",
      externalLink: "mailto:dporterfield@nouveaurichelegacy.com?subject=Portfolio%20Entry",
      cta: "Submit Portfolio"
    },
    {
      id: "branding",
      title: "Branding",
      subtitle: "Elevate Your Presence",
      description: "Branding helps you define your vision, elevate your presence, and stand out with intention. Click to build a brand that aligns with who you are and where you're going.",
      image: "https://static.wixstatic.com/media/57e31dbf58d44095a1173a5517ba75bd.jpg",
      link: "/media-services",
      externalLink: "https://www.nouveaurichelegacy.com/booking-calendar/business-consultation",
      cta: "Book Consult"
    },
    {
      id: "websites",
      title: "Websites",
      subtitle: "Digital Home",
      description: "Websites turn your vision into a digital home that works for you. Click to create a clean, intentional site that showcases your brand and drives results.",
      image: "https://static.wixstatic.com/media/11062b_31fcefa60a2e4659a556237badf702e1~mv2.jpg",
      link: "/media-services",
      externalLink: "https://www.nouveaurichelegacy.com/booking-calendar/business-consultation",
      cta: "Book Consult"
    },
    {
      id: "photography",
      title: "Photography & Fine Art",
      subtitle: "Capture Your Story",
      description: "Photography services are crafted to capture your story with intention, depth, and luxury. Each shoot is designed to elevate your image, align with your brand, and turn visuals into currency that speaks power, presence, and legacy.",
      image: "https://static.wixstatic.com/media/11062b_cdde939992964b469aafdcfb6e07bb55~mv2.jpg",
      link: "/media-services",
      externalLink: "https://www.nouveaurichelegacy.com/booking-calendar/business-consultation",
      cta: "Book Session"
    },
    {
      id: "trading",
      title: "Trading Hub",
      subtitle: "Stocks • Crypto • Forex",
      description: "Learn and practice trading with real market data. Paper trading lets you build confidence before investing real money.",
      image: "https://images.pexels.com/photos/534216/pexels-photo-534216.jpeg",
      link: "/trading",
      cta: "Start Trading"
    }
  ],
  
  // Fashion Products - Your actual products from the website
  products: [
    // OUTERWEAR
    { product_id: "ce-denim-jacket", name: "CE Unisex Denim Jacket", description: "Premium unisex denim jacket with Courtney Eslyn branding", price: 89.99, image_url: "https://static.wixstatic.com/media/95e2db_b4e8aa67fc9045adb6a5bcbb0c370321~mv2.jpg", category: "Outerwear", in_stock: false },
    { product_id: "ce-sherpa-jacket", name: "CE Unisex Denim Sherpa Jacket", description: "Premium sherpa-lined denim jacket with Courtney Eslyn branding", price: 99.99, image_url: "https://static.wixstatic.com/media/95e2db_897ea1267b274333b301fe5b4a74f911~mv2.jpg", category: "Outerwear", in_stock: false },
    { product_id: "nrl-sherpa-jacket", name: "NRL Unisex Denim Sherpa Jacket", description: "Premium sherpa-lined denim jacket with NRL branding", price: 99.99, image_url: "https://static.wixstatic.com/media/95e2db_05ab8e89219d41c99d31823e8fc3b9fa~mv2.jpg", category: "Outerwear", in_stock: false },
    
    // APPAREL
    { product_id: "nrl-long-sleeve", name: "NRL Long Sleeve Shirt", description: "Classic long sleeve shirt with NRL branding", price: 35.00, image_url: "https://static.wixstatic.com/media/95e2db_ed225b7155864641aeaba1de35bc0ef4~mv2.jpg", category: "Apparel", in_stock: true },
    { product_id: "nrl-hoodie", name: "Unisex Heavy Blend Hoodie | Gildan 18500", description: "Comfortable heavy blend hoodie with NRL logo", price: 35.75, image_url: "https://static.wixstatic.com/media/95e2db_f7595cf66a914e9eaa2ee0a50b1a1c14~mv2.png", category: "Apparel", in_stock: true },
    { product_id: "nrl-tshirt", name: "Unisex Staple T-Shirt | Bella + Canvas 3001", description: "Premium staple t-shirt with NRL design", price: 19.75, image_url: "https://static.wixstatic.com/media/95e2db_ffbe029a067142b68d1f2158e06e389c~mv2.png", category: "Apparel", in_stock: true },
    { product_id: "nrl-crewneck", name: "Unisex Crew Neck Sweatshirt | Gildan 18000", description: "Classic crew neck sweatshirt with NRL branding", price: 30.25, image_url: "https://static.wixstatic.com/media/95e2db_e5c49a3d1b134edf888861318a79e776~mv2.png", category: "Apparel", in_stock: true },
    
    // HEADWEAR
    { product_id: "nrl-trucker-hat", name: "Retro Trucker Hat | Yupoong 6606", description: "Classic trucker hat with NRL logo", price: 27.75, image_url: "https://static.wixstatic.com/media/95e2db_9512844d24884612a066162a0ccb9662~mv2.png", category: "Headwear", in_stock: true },
    { product_id: "nrl-beanie", name: "Cuffed Beanie | Yupoong 1501KC", description: "Warm cuffed beanie with NRL branding", price: 26.00, image_url: "https://static.wixstatic.com/media/95e2db_4a9200b60ef141d6927c1e4d7f1cfaf5~mv2.png", category: "Headwear", in_stock: true },
    
    // DRINKWARE
    { product_id: "nrl-black-mug", name: "Nouveau Riche Legacy Black Glossy Mug", description: "Premium black glossy mug with NRL gold logo", price: 15.99, image_url: "https://static.wixstatic.com/media/95e2db_1537375a577f481db50796620c953c7d~mv2.jpg", category: "Drinkware", in_stock: true },
    { product_id: "ce-black-mug", name: "Courtney Eslyn Black Glossy Mug", description: "Premium black glossy mug with CE branding", price: 15.99, image_url: "https://static.wixstatic.com/media/95e2db_b485bf8738b34eb2a3a2b3b7dff3ed94~mv2.jpg", category: "Drinkware", in_stock: true },
    { product_id: "nrl-og-mug", name: "Nouveau Riche Legacy OG Logo Black Glossy Mug", description: "Premium black glossy mug with original NRL logo", price: 15.99, image_url: "https://static.wixstatic.com/media/95e2db_b5ed4bc5695d4313a83182aae7e89f33~mv2.jpg", category: "Drinkware", in_stock: true },
    { product_id: "nrl-white-mug", name: "White Glossy Mug", description: "Classic white glossy mug with NRL logo", price: 11.25, image_url: "https://static.wixstatic.com/media/95e2db_7ab7b2bbf761463bb7e635ba10a1e1a8~mv2.png", category: "Drinkware", in_stock: true },
    { product_id: "nrl-og-bottle", name: "NRL OG Logo Stainless Steel Water Bottle", description: "Premium stainless steel water bottle with straw lid and OG logo", price: 29.99, image_url: "https://static.wixstatic.com/media/95e2db_e7afbd8f1672412f8d0977c7257e1e88~mv2.jpg", category: "Drinkware", in_stock: true },
    { product_id: "nrl-gold-bottle", name: "NRL Black & Gold Stainless Steel Water Bottle", description: "Premium stainless steel water bottle with black and gold design", price: 29.99, image_url: "https://static.wixstatic.com/media/95e2db_87c5a3e1d740453cbfe4e5f27b2feaf1~mv2.jpg", category: "Drinkware", in_stock: true },
    { product_id: "ce-bottle", name: "CE Stainless Steel Water Bottle", description: "Premium stainless steel water bottle with Courtney Eslyn branding", price: 29.99, image_url: "https://static.wixstatic.com/media/95e2db_ec377388dc0c40bbb7148b3f5e2d110e~mv2.jpg", category: "Drinkware", in_stock: true },
    { product_id: "ce-bottle-alt", name: "Courtney Eslyn Stainless Steel Water Bottle", description: "Premium stainless steel water bottle with CE signature", price: 29.99, image_url: "https://static.wixstatic.com/media/95e2db_b3021d22e65e486e934c9d07cf8f76d7~mv2.jpg", category: "Drinkware", in_stock: true },
    { product_id: "nrl-bottle", name: "NRL Stainless Steel Water Bottle", description: "Premium stainless steel water bottle with NRL logo", price: 29.99, image_url: "https://static.wixstatic.com/media/95e2db_8999824d9ae2421c8342a6e60a8d74b2~mv2.jpg", category: "Drinkware", in_stock: true },
    { product_id: "parvenu-bottle", name: "Parvenu Stainless Steel Water Bottle", description: "Premium stainless steel water bottle with Parvenu branding", price: 29.99, image_url: "https://static.wixstatic.com/media/95e2db_83902cd985234e2da2713bf6b93b0407~mv2.jpg", category: "Drinkware", in_stock: true },
    
    // ACCESSORIES
    { product_id: "nrl-stickers", name: "Kiss-Cut Stickers", description: "High quality kiss-cut stickers with NRL logo", price: 4.50, image_url: "https://static.wixstatic.com/media/95e2db_f604d5497f8343a28a08071515cbb727~mv2.png", category: "Accessories", in_stock: true },
  ],
  
  // About Section Content
  about: {
    title: "About Nouveau Riche Legacy",
    subtitle: "Closing the Wealth Gap, For Real",
    paragraphs: [
      "Nouveau Riche Legacy is a Black-owned, woman-led platform built to close the wealth gap for real.",
      "We merge financial literacy, credit strategy, artistic expression, AI, and Web3 innovation to help individuals, entrepreneurs, and businesses build structure, access capital, and create generational wealth.",
      "This is not just education. It is an application.",
      "Whether you are repairing personal credit, positioning a business for funding, or building a brand rooted in culture and legacy, we provide the tools, strategy, and guidance to move you forward.",
      "Book a strategy call. Build with intention. Create a legacy that lasts."
    ],
    image: "https://static.wixstatic.com/media/11062b_9b52a0adb0ac4756a04a9e7aeaa7ce3d~mv2.jpeg"
  },
  
  // Media Services Details
  mediaServices: [
    {
      id: "consultation",
      title: "Business Consultation",
      description: "Consultations are designed to give you clarity, strategy, and a personalized path forward.",
      price: "Starting at $150/hour",
      includes: ["Business Strategy", "Market Analysis", "Action Plan", "Follow-up Support"]
    },
    {
      id: "branding",
      title: "Branding",
      description: "Define your vision, elevate your presence, and stand out with intention.",
      price: "Starting at $500",
      includes: ["Logo Design", "Brand Guidelines", "Color Palette", "Typography Selection", "Brand Voice"]
    },
    {
      id: "website",
      title: "Website Design",
      description: "Turn your vision into a digital home that works for you.",
      price: "Starting at $1,500",
      includes: ["Custom Design", "Mobile Responsive", "SEO Optimization", "CMS Integration", "Training"]
    },
    {
      id: "photography",
      title: "Photography & Fine Art",
      description: "Capture your story with intention, depth, and luxury.",
      price: "Starting at $300/session",
      includes: ["Professional Shoot", "Photo Editing", "Digital Delivery", "Print Rights", "Creative Direction"]
    }
  ]
};

export default SITE_CONFIG;
